import React from "react";

import Difficulties1 from "../../../../assets/HomePage/Difficulties1Img.png";
import Difficulties2 from "../../../../assets/HomePage/Difficulties2Img.png";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Paper, Typography, Grid } from "@mui/material";

const Difficulties = () => {
  return (
    <Paper
      elevation={20}
      sx={{ padding: { xs: "2rem", md: "4rem" }, mt: "6rem", borderRadius: 5 }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: "bold",
          textAlign: "center",
          color: "secondary.main",
          mb: "1rem",
        }}
      >
        THE JOURNEY
      </Typography>
      <Typography
        variant="h4"
        component="h2"
        sx={{
          fontWeight: "bold",
          maxWidth: { xs: "100%", sm: "70%" },
          textAlign: "center",
          mx: "auto",
        }}
      >
        Running a successful business is difficult. Running it alone is harder.
      </Typography>
      <Typography variant="body1" sx={{ mt: "1.2rem", textAlign: "center" }}>
        Are you lonely, burning out, facing imposter syndrome, experiencing
        emotional rollercoasters, or stressing over the endless decisions you
        need to make on a daily basis?
      </Typography>
      <Typography variant="body1" sx={{ mt: "1.2rem", textAlign: "center" }}>
        We understand. <b>That's what The 100 Club is here to solve.</b>
      </Typography>
      <Grid
        container
        spacing={6}
        sx={{ my: "3rem", textAlign: "center" }}
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item lg={6}>
          <img
            src={Difficulties1}
            alt="DifficultiesImage"
            style={{ width: "100%", height: "auto" }}
          />
          <Grid direction="column" alignItems="center" justifyContent="center">
            <Typography
              variant="h5"
              component="h2"
              sx={{ fontWeight: "bold", mt: "3rem" }}
            >
              Nobody to turn to in times of need?
            </Typography>
            <List sx={{ maxWidth: { xs: "100%", sm: "100%" } }}>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText primary="Your family can't empathise." />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText primary="Your business network consists of superficial relationships who only talk about themselves." />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText primary="Your investors don’t want to hear you don’t know what you’re doing after they’ve invested in you." />
              </ListItem>
            </List>
          </Grid>
        </Grid>
        <Grid item lg={6}>
          <img
            src={Difficulties2}
            alt="DifficultiesImage"
            style={{ width: "100%", height: "auto" }}
          />
          <Grid direction="column" alignItems="center" justifyContent="center">
            <Typography
              variant="h5"
              component="h2"
              sx={{ fontWeight: "bold", mt: "3rem" }}
            >
              Stuck in an echo chamber?
            </Typography>
            <List sx={{ maxWidth: { xs: "100%", sm: "100%" } }}>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText primary="You're too tired to prioritise and think deeply about important problems." />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText primary="You are having trouble making decisions and struggle with the uncertainity." />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText primary="You feel like you're not making meaningful progress." />
              </ListItem>
            </List>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Difficulties;
